import { useTranslation } from "react-i18next";
import { FaCheck, FaTimes } from "react-icons/fa";

const ApproveDeclineAll = ({
  onApproveModalOpen,
  onDeclineModalOpen,
}: {
  onApproveModalOpen: () => void;
  onDeclineModalOpen: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-20">
      <div className="row gap-8 mb-10">
        <button
          onClick={() => onApproveModalOpen()}
          className="card-action-button p-4 row row-center row-v-center"
        >
          <FaCheck />
        </button>
        <div className="f-weight-7 f-16">{t("acceptPrintData")}</div>
      </div>
      <div className="row gap-8 mb-10">
        <button
          onClick={() => onDeclineModalOpen()}
          className="card-action-button p-4 row row-center row-v-center"
        >
          <FaTimes />
        </button>
        <div className="f-weight-7 f-16">{t("declinePrintData")}</div>
      </div>
    </div>
  );
};

export default ApproveDeclineAll;
